<template>
  <div>
    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- strat -->
      <el-tab-pane :label="tablabel" name="first">
        <div class="block">
          <el-button type="info" class="mt20" @click="backCustomerManagement">返回</el-button>
        </div>

        <el-table :data="dataList" border stripe class="mt15">
          <el-table-column prop="Listorder" label="排序" min-width="5%"></el-table-column>
          <el-table-column prop="Content" label="内容" min-width="80%"></el-table-column>
          <el-table-column prop="operation" label="操作" min-width="15%">
            <template v-slot="scope">
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 6px" @click="clickEdit(scope.row)">修改</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 6px" @click="clickDel(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
			:current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- end -->

      <!-- 添加 start -->
      <el-tab-pane label="添加" name="second">
        <el-form :model="addData" ref="addDataRef" label-width="120px">
          <el-form-item label="内容" class="addAdminForm">
            <el-input v-model="addData.content" placeholder="请输入内容"></el-input>
          </el-form-item>
          <el-form-item class="mt20">
            <el-button type="primary" @click="clickAdd">保存</el-button>
            <el-button type="info" @click="clickreturn">返回</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <!-- 添加 end -->

      <!-- 修改 start -->
      <el-tab-pane label="修改" name="three">
        <el-form :model="editData" ref="editDataRef" label-width="120px">
          <el-form-item label="内容" class="addAdminForm">
            <el-input v-model="editData.content" placeholder="请输入内容"></el-input>
          </el-form-item>
          <el-form-item label="排序" class="addAdminForm">
            <el-input v-model="editData.listorder" placeholder="请输入排序"></el-input>
          </el-form-item>
          <el-form-item class="mt20">
            <el-button type="primary" @click="clickModify">保存</el-button>
            <el-button type="info" @click="clickreturn">返回</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <!-- 修改 end -->

    </el-tabs>
    <!-- Tabs end -->
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  data () {
    return {
      activeName: 'first',
      tablabel:'',
      selectedPageNo: 1,
      dataList: [],
      dataListnum: 0,
      productid: '',
      infotype:0,
      addData: {
        content: ''
      },
      editData: {
        id: '',
        content: '',
        listorder:''
      }
    }
  },
  mounted () {
  },
  methods: {
    LoadData (row,infotype) {
      this.productid = row.Id
      this.infotype = infotype
      if(this.infotype == 1){
        this.tablabel = '免费服务'
      }
      if(this.infotype == 2){
        this.tablabel = '包装'
      }
      if(this.infotype == 3){
        this.tablabel = '售后服务1'
      }
      if(this.infotype == 4){
        this.tablabel = '售后服务2'
      }
      this.GetKgjtWebsiteErpProductInfoNum()
      this.GetKgjtWebsiteErpProductInfoList()
    },
    backCustomerManagement () {
      this.$emit('triggerFunc', '')
    },
    handleCurrentPageChange (selectedPageNo) {
      this.GetKgjtWebsiteErpProductInfoList()
    },
    clickreturn () {
      this.activeName = 'first'
    },
    clickAdd () {
      this.AddKgjtWebsiteErpProductInfo()
    },
    clickEdit (row) {
      this.editData.id = row.Id
      this.editData.content = row.Content
      this.editData.listorder = row.Listorder
      this.activeName = 'three'
    },
    clickDel(row){
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.DelKgjtWebsiteErpProductInfo(row)
      })
    },
    clickModify () {
      this.EditKgjtWebsiteErpProductInfo()
    },
    GetKgjtWebsiteErpProductInfoList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        productid: that.productid,
        infotype: that.infotype
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetKgjtWebsiteErpProductInfoList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    GetKgjtWebsiteErpProductInfoNum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        productid: that.productid,
        infotype: that.infotype
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetKgjtWebsiteErpProductInfoNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    AddKgjtWebsiteErpProductInfo: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        productid: that.productid,
        infotype: that.infotype,
        content: that.addData.content
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_AddKgjtWebsiteErpProductInfo, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.GetKgjtWebsiteErpProductInfoNum()
            that.GetKgjtWebsiteErpProductInfoList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    EditKgjtWebsiteErpProductInfo: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        productid: that.productid,
        id: that.editData.id,
        infotype: that.infotype,
        content: that.editData.content,
        listorder: that.editData.listorder
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_EditKgjtWebsiteErpProductInfo, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'
            that.GetKgjtWebsiteErpProductInfoList()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    DelKgjtWebsiteErpProductInfo: function (row) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        id: row.Id
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_DelKgjtWebsiteErpProductInfo, Qs.stringify(data))
        .then(function (response) {
          that.GetKgjtWebsiteErpProductInfoNum()
          that.GetKgjtWebsiteErpProductInfoList()
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
